import { render } from "./StickyDemo.vue?vue&type=template&id=0d2db1b2&scoped=true"
import script from "./StickyDemo.vue?vue&type=script&lang=ts"
export * from "./StickyDemo.vue?vue&type=script&lang=ts"

import "./StickyDemo.vue?vue&type=style&index=0&id=0d2db1b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d2db1b2"

export default script